module.exports = __webpack_public_path__ + "static/img/zsbj.8cc2c672.png";